// extracted by mini-css-extract-plugin
export default {"NewLibraryDialog":"NewLibraryDialog_NewLibraryDialog__AFCez"};